import { FC, ReactNode } from "react"
import PrimaryBtn from "../../../../buttons/primary-btn"
import DefaultBtn from "../../../../buttons/default-btn"

type ButtonVariant = "primary" | "secondary"

interface ConnectorFormButtonProps {
  children: ReactNode
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  variant?: ButtonVariant
  disabled?: boolean
  type?: "button" | "submit" | "reset"
  size?: "sm" | "base" | "md" | "lg"
  className?: string
}

const ConnectorFormButton: FC<ConnectorFormButtonProps> = ({
  children,
  onClick,
  variant = "primary",
  disabled = false,
  type = "button",
  size = "sm",
  className = ""
}) => {
  const buttonProps = {
    onClick,
    disabled,
    type,
    size,
    className
  }

  if (variant === "secondary") {
    return <DefaultBtn {...buttonProps}>{children}</DefaultBtn>
  }

  return <PrimaryBtn {...buttonProps}>{children}</PrimaryBtn>
}

export default ConnectorFormButton
